import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    getLengt_arraybk,
} from '../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front_Buyer from "../../../pages/Master_Front_Buyer";

import ReactFullPageLoadinghk from "../../../components/layaout/LoadingFullpagehk";
import Card_Suggested_vendors_view from "../../../components/Grid_box/Card_Suggested_vendors_view";


import serialize from "form-serialize";

import Grid from "@mui/material/Grid";
import {Skeleton} from "@mui/material";



const Suggested_vendors = (props) => {

    const location = useLocation()


    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [profile_src, setData_profile_src] = useState('');
    const [type_user_panel, setData_type_user_panel] = useState('');

    /*  end profile */

    const [active_tab_curent, set_active_tab_curent] = useState("tab1")

    const [cat_list_full, setData_cat_list_full] = useState([]);



    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register" );
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page = () => {

        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };


        Setloadinghkfullshow("true");


        let form_data = document.querySelector('#form_data');
        if (form_data != null) {

            let data_serialize = serialize(form_data);


            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/suggested-vendors`, data_serialize, config)


                .then((res) => {
                    Setloadinghkfullshow("false");
///console.log(res.data);
                    if (String(res.data).length > 0) {

                        if (String(res.data.data) == "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                        }

                        if (!empty_bk(res.data.type_user)) { setData_type_user_panel(res.data.type_user); }


                        if (String(res.data.wallet_inventory).length > 0) {
                            setData_wallet_balance(res.data.wallet_inventory);
                        }
                        if (!empty_bk(res.data.first_name_profile)) {
                            setData_first_name_profile(res.data.first_name_profile);
                            localStorage.setItem('first_name_Get', res.data.first_name_profile);
                        }
                        if (!empty_bk(res.data.last_name_profile)) {
                            setData_last_name_profile(res.data.last_name_profile);
                            localStorage.setItem('last_name_Get', res.data.last_name_profile);
                        }
                        if (!empty_bk(res.data.profile_src)) {
                            setData_profile_src(res.data.profile_src);
                        }


                        if(getLengt_arraybk(res.data.data_list_posts) > 0 ) {  setData_cat_list_full(res.data.data_list_posts); }else{  setData_cat_list_full([]);  }



                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطا اتصال به سرور کد  435346', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });


        }


    }








    return (<Fragment>

<style jsx>{`



`}</style>


            <Master_Front_Buyer type_user_panel={type_user_panel} wallet_balance={wallet_balance} first_name_profile={first_name_profile}
                          last_name_profile={last_name_profile} profile_src={profile_src}>
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                <ToastContainer/>


                <div className={"box-content-panelbk"}>

                    <span className={"title-box-content-panel"}>فروشندگان پیشنهادی</span>

                    <form id={"form_data"} name={"form_data"} encType="multipart/form-data" style={{width: "100%"}}>

<div className={"container-bk"}>

    {

        cat_list_full.length == 0 ? (
            <React.Fragment>

                <Skeleton variant="rectangular" style={{width:"100%",height:"180px",borderRadius:"10px"}}/>

            </React.Fragment>


        ) : (
            <Fragment>

                <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>

                    {

                        cat_list_full.map((item_post, index) => {

                            return (

                                <Grid item lg={3} md={3} sm={6} xs={6}>
                                    <Card_Suggested_vendors_view  link_to={"/"} data_full_curent_item={item_post}    />
                                </Grid>

                            );

                        })

                    }

                </Grid>

            </Fragment>

        )
    }


</div>





                    </form>

                </div>


            </Master_Front_Buyer>
        </Fragment>
    );
}


export default Suggested_vendors;